// extracted by mini-css-extract-plugin
export default {"modal":"mca-z","modalContent":"nca-z","footer":"oca-z","cancelBtn":"pca-z","disabled":"qca-z","formWrapper":"rca-z","fade":"sca-z","fade-in":"tca-z","iframe":"uca-z"};